import React, { Component } from "react";
import MainRoutes from "./components/routes/MainRoutes";
import PublicRoutes from "./components/routes/PublicRoutes";
// import { AdminRoutes } from "./components/routes/AdminRoutes";
import moment from "moment-timezone";
import { Redirect, Route, Switch } from "react-router-dom";
import { languages } from "./constants/languages";
import AccountContainer from "./containers/AccountContainer";
import AdminContainer from "./containers/admin/AdminContainer";
import ArenalAdminContainer from "./containers/admin/ArenalDashboardContainer";
import PSDAdminContainer from "./containers/admin/PSDAdminContainer";
import RVDashboardContainer from "./containers/admin/RVDashboardContainer";
import SportaAdminContainer from "./containers/admin/SportaAdminContainer";
import UserContainer from "./containers/admin/UserContainer";
import AnonymousContainer from "./containers/AnonymousContainer";
import FeatureDetailsContainer from "./containers/features/FeatureDetailsContainer";
import FeaturesContainer from "./containers/features/FeaturesContainer";
import LoginContainer from "./containers/LoginContainer";
import MollieConnectContainer from "./containers/MollieConnectContainer";
import PSDLoginContainer from "./containers/PSDLoginContainer";
import SportaLoginContainer from "./containers/SportaLoginContainer";
import TournamentContainer from "./containers/TournamentContainer";
// import FeaturesSnackbar from "./components/FeaturesSnackbar";

class Auth extends Component {
  state = {
    user: undefined,
    userLoaded: false,
    admins: [],
    // openSnackbar: true
    userData: undefined,
    userDataLoaded: false,
  };

  // handleClose = () => {
  //   this.setState({ openSnackbar: false });
  // };

  setAuthListener = () => {
    this.listener && this.listener();
    this.listener = window.firebase.auth().onAuthStateChanged(
      function (user) {
        if (user) {
          // User is signed in.
          // var displayName = user.displayName;
          // var email = user.email;
          // var emailVerified = user.emailVerified;
          // var photoURL = user.photoURL;
          // var isAnonymous = user.isAnonymous;
          // var providerData = user.providerData;

          // log sign in activity
          // window.firebase
          //   .database()
          //   .ref("activity")
          //   .push({
          //     date: moment().unix(),
          //     email: user.email,
          //     uid: user.uid,
          //     type: 0
          //   });

          this.setState({ user: user, userLoaded: true });
          this.loadUserData(user);
        } else {
          // User is signed out.
          this.setState({
            user: undefined,
            userLoaded: true,
            userData: undefined,
            userDataLoaded: true,
          });
        }
      }.bind(this)
    );
  };

  UNSAFE_componentWillMount = () => {
    this.setAuthListener();

    window.firebase
      .firestore()
      .collection("admins")
      .get()
      .then((querySnapshot) => {
        let admins = [];
        querySnapshot.forEach(function (doc) {
          admins.push(doc.id);
        });
        this.setState({ admins: admins });
      });
  };

  componentWillUnmount = () => {
    this.listener && this.listener();
  };

  loadUserData = (user) => {
    const userDoc = window.firebase
      .firestore()
      .collection("users")
      .doc(user.uid);

    userDoc.get().then((doc) => {
      if (doc.exists) {
        this.setState({ userData: doc.data(), userDataLoaded: true });
      } else {
        let userData = {
          name: user.displayName,
          email: user.email,
          registeredOn: moment().unix(),
        };
        if (user.email) {
          userDoc.set(userData);
        }
        this.setState({ userData: userData, userDataLoaded: true });
      }
    });
  };

  render() {
    let toRender = null;
    // let openSnackbar = false;
    if (this.state.userLoaded && this.state.userDataLoaded) {
      if (this.state.user && !this.state.user.isAnonymous) {
        // openSnackbar = this.state.openSnackbar;
        // if (this.state.userData) {
        //   toRender = "Main routes";
        // }
        if ((this.state.userData || {}).isPSD) {
          let psdLang = this.state.userData.psdLang;
          const validLanguages = ["nl", "en", "de", "fr", "es", "pl"];
          if (
            !localStorage.getItem("userLanguage") &&
            validLanguages.indexOf(psdLang) !== -1
          ) {
            languages.setLanguage(psdLang);
          }
        }
        const psdAdmins = [
          "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
          "sOXBd83e27e3DOIRNaLE6f5Oesc2", // PSD (info)
        ];
        let isPSDAdmin = psdAdmins.indexOf((this.state.user || {}).uid) !== -1;
        const sportaAdmins = [
          "c9cdoS2iGcb3sJ1MFVDXIjzzUNs2", // Bert
          "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
        ];
        let isSportaAdmin =
          sportaAdmins.indexOf((this.state.user || {}).uid) !== -1;
        const rvAdmins = [
          "NKuutwfS9xg1DAKAkb86tIubqyJ2", // Michel
          "yuZSGcZhb5bjfzMAcZumEcnJ9j63", // Mathias
          "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
        ];
        let isRVAdmin = rvAdmins.indexOf((this.state.user || {}).uid) !== -1;

        const arenalAdmins = [
          "Os3Bv6BAi8S3esABDGabzBCmvAI3", // Glenn
          "PC2wBQrN49a1EHjhUOFnJcIK4iv2", // Lotte (Arenal Mechelen)
          "qwVXeKNiBzMz3RyUJSAJFLrkFnH2", // Abel
        ];
        let isArenalAdmin =
          arenalAdmins.indexOf((this.state.user || {}).uid) !== -1;

        toRender = (
          <Switch>
            {/* {!isPSDUser && ( */}
            <Route
              path="/"
              exact
              render={() => (
                <MainRoutes
                  user={this.state.user}
                  userData={this.state.userData}
                />
              )}
            />
            {/* )} */}
            <Route
              path="/login/:psdCode"
              exact
              render={(path) => (
                <LoginContainer psdCode={path.match.params.psdCode} />
              )}
            />
            <Route
              path="/features/:featureId"
              render={(path) => (
                <FeatureDetailsContainer
                  user={this.state.user}
                  featureId={path.match.params.featureId}
                  admins={this.state.admins}
                  userData={this.state.userData}
                />
              )}
            />
            <Route
              path="/features"
              render={() => (
                <FeaturesContainer
                  user={this.state.user}
                  userData={this.state.userData}
                />
              )}
            />
            <Route
              path="/account"
              render={() => <AccountContainer user={this.state.user} />}
            />
            <Route
              path="/mollieconnectcallback"
              render={() => <MollieConnectContainer user={this.state.user} />}
            />
            <Route
              path="/tournament/:tournamentId"
              render={(path) => (
                <TournamentContainer
                  tournamentId={path.match.params.tournamentId}
                  user={this.state.user}
                  userData={this.state.userData}
                  admins={this.state.admins}
                />
              )}
            />
            {/* <AdminRoutes user={this.state.user} admins={this.state.admins} /> */}
            {isPSDAdmin && (
              <Route
                path="/psdadmin"
                exact
                render={() => (
                  <PSDAdminContainer
                    user={this.state.user}
                    isTournifyAdmin={
                      this.state.admins.indexOf(this.state.user.uid) !== -1
                    }
                  />
                )}
              />
            )}
            {isSportaAdmin && (
              <Route
                path="/sportaadmin"
                exact
                render={() => (
                  <SportaAdminContainer
                    user={this.state.user}
                    isTournifyAdmin={
                      this.state.admins.indexOf(this.state.user.uid) !== -1
                    }
                  />
                )}
              />
            )}
            {isRVAdmin && (
              <Route
                path="/belgiumrugby"
                exact
                render={() => (
                  <RVDashboardContainer
                    user={this.state.user}
                    isTournifyAdmin={
                      this.state.admins.indexOf(this.state.user.uid) !== -1
                    }
                  />
                )}
              />
            )}
            {isArenalAdmin && (
              <Route
                path="/arenaladmin"
                exact
                render={() => (
                  <ArenalAdminContainer
                    user={this.state.user}
                    isTournifyAdmin={
                      this.state.admins.indexOf(this.state.user.uid) !== -1
                    }
                  />
                )}
              />
            )}
            <Route
              path="/admin"
              exact
              render={() => (
                <AdminContainer
                  user={this.state.user}
                  admins={this.state.admins}
                />
              )}
            />
            <Route
              path="/admin/:uid"
              exact
              render={(path) => (
                <UserContainer
                  admins={this.state.admins}
                  user={this.state.user}
                  uid={path.match.params.uid}
                />
              )}
            />
            {/* {!isPSDUser && ( */}
            <Route
              path="/new"
              render={() => (
                <AnonymousContainer
                  user={this.state.user}
                  userData={this.state.userData}
                />
              )}
            />
            {/* )} */}
            <Route
              path="/prosoccerdata/:psdCode"
              render={(path) => (
                <AnonymousContainer
                  user={this.state.user}
                  psdCode={path.match.params.psdCode}
                />
              )}
            />
            <Route
              path="/i-reservations/:iResCode"
              render={(path) => (
                <AnonymousContainer
                  user={this.state.user}
                  iResCode={path.match.params.iResCode}
                />
              )}
            />
            <Route
              path="/psd/:code/:tournamentId"
              render={(path) => (
                <PSDLoginContainer
                  code={path.match.params.code}
                  tournamentId={path.match.params.tournamentId}
                />
              )}
            />
            <Route
              path="/sporta/:code"
              render={(path) => (
                <SportaLoginContainer code={path.match.params.code} />
              )}
            />
            <Route path="*" render={() => <Redirect to="/" />} />
          </Switch>
        );
      } else {
        // openSnackbar = false;
        toRender = (
          <PublicRoutes
            user={this.state.user}
            userData={this.state.userData}
            setAuthListener={this.setAuthListener}
          />
        );
      }
    }

    return (
      <div>
        {/* <FeaturesSnackbar open={openSnackbar} handleClose={this.handleClose} /> */}
        {toRender}
      </div>
    );
  }
}

export default Auth;
